module.exports = __webpack_public_path__ + "static/img/6.d2be718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/6.png
// module id = K823
// module chunks = 0